export enum DisplayPurposesEnum {
  Positive = 'positive',
  Neutral = 'neutral',
  Warning = 'warning',
  Negative = 'negative',
  Disabled = 'disabled',
  Invert = 'invert',
}

export type DisplayPurposeProps = {
  purposes: DisplayPurposesEnum;
  variants?: 'neutral' | 'positive' | 'warning' | 'negative' | 'brand';
};

export const DisplayVariants = [
  'neutral',
  'positive',
  'warning',
  'negative',
  'brand',
] as const satisfies readonly NonNullable<DisplayPurposeProps['variants']>[];
